import Main from './containers/MainPage'

function App() {
  return (
    <Main/>
  );
}

export default App;
